import { render, staticRenderFns } from "./AsignacionMunicionCurso.vue?vue&type=template&id=3d19b836"
import script from "./AsignacionMunicionCurso.vue?vue&type=script&lang=js"
export * from "./AsignacionMunicionCurso.vue?vue&type=script&lang=js"
import style0 from "./AsignacionMunicionCurso.vue?vue&type=style&index=0&id=3d19b836&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports